import { selectMerchant } from "@redux";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { WarningIcon } from "../icon/WarningIcon";
interface IProps {
    onClose: () => void;
    text: string;
}

export default function PopupWarning({ onClose, text }: IProps) {
    const { themes } = useSelector(selectMerchant);
    const { t } = useTranslation();
    return (
        <StyledPopupWarning themeColor={themes?.themeColor!}>
            <div className="box-popupconfirm">
                <div className="title">
                    <div className="image">
                        <WarningIcon />
                    </div>
                    <div className="text-sub-header">{text}</div>

                    <div className="btn-popupconfirm">
                        <button className="btn-cancel" onClick={() => onClose()}>
                            {t("page.done")}
                        </button>
                    </div>
                </div>
            </div>
        </StyledPopupWarning>
    );
}

const StyledPopupWarning = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .btn-popupconfirm {
            margin-top: 16px;
            .btn-cancel {
                display: flex;
                padding: 14.5px 32px;
                justify-content: center;
                align-items: center;
                gap: 8px;
                align-self: stretch;
                border-radius: 14px;
                background: ${(p) => p.themeColor};
                border: none;
                color: #fff;
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .image {
            margin-bottom: 10px;
        }
        .text-sub-header {
            text-align: center;
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
    }
`;
